import React from 'react';

import Connect from './connect';
import Disconnect from './disconnect';
import NylasGrant from './index';
import Status from './status';
import gmailIcon from 'assets/images/logos/gmail.svg';
import googleIcon from 'assets/images/logos/google.svg';

import { scopesFor } from './scopes';

import type { GrantProps } from './types';

export function GoogleGrant({ grant, paths, canSendEmail, onDestroy }: GrantProps) {
  const canConnect = !grant || grant.expired;
  const scopes = scopesFor('google', canSendEmail);

  return (
    <NylasGrant
      icon={gmailIcon}
      label="Gmail"
      status={grant && <Status grant={grant} />}
    >
      {canConnect &&
        <Connect
          grant={grant}
          icon={googleIcon}
          label="Google"
          path={paths.auth}
          providerName="google"
          scopes={scopes}
        />
      }

      {grant &&
        <Disconnect
          destroyPath={paths.destroy}
          variant={canConnect ? 'destructive' : 'ghost'}
          onDestroy={onDestroy}
        />
      }
    </NylasGrant>
  );
}
